import { render, staticRenderFns } from "./restrict.vue?vue&type=template&id=60f74f20&scoped=true"
import script from "./restrict.vue?vue&type=script&lang=js"
export * from "./restrict.vue?vue&type=script&lang=js"
import style0 from "./restrict.vue?vue&type=style&index=0&id=60f74f20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f74f20",
  null
  
)

export default component.exports